import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBrowserEvents]'
})
export class BrowserEventsDirective {

   @HostListener("window:beforeunload", ["$event"]) beforeUnloadHandler(event: Event) {
      event.returnValue = false;
    }
    @HostListener("window:unload", ["$event"]) unloadHandler(event: Event) {
      event.returnValue = false;
    }

  constructor() { }

}
